var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Success = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M10 1.6C14.65 1.6 18.4 5.4 18.4 10C18.4 14.6 14.65 18.4 10 18.4C5.35 18.4 1.6 14.65 1.6 10C1.6 5.35 5.35 1.6 10 1.6ZM10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0Z" }),
    React.createElement("path", { fill: "currentColor", d: "M8.69998 14.6L5.34998 11.15L6.39998 10.1L8.64998 12.35L13.75 6.45001L14.85 7.45001L8.69998 14.6Z" }))); });
//# sourceMappingURL=Success.js.map